import React from "react";
import { Chart } from "react-google-charts";

const data = [
  ["State", "Subscription"],
  ["Andhra Pradesh", 200],
  ["Tamil Nadu", 300],
  ["Karnataka", 400],
  ["Maharashtra", 300],
  ["Delhi", 500],
  ["Uttar Pradesh", 500],
  ["West Bengal", 350],
  ["Kerala", 250],
  ["Gujarat", 1500],
  ["Rajasthan", 300],
  ["Madhya Pradesh", 20],
];

const options = {
  region: "IN",
  displayMode: "regions",
  resolution: "provinces",
  tooltip: {
    textStyle: { color: "#000000", fontSize: 12 },
    showColorCode: true,
    trigger: "focus",
  },
  colorAxis: {
    values: [0, 100, 250, 500, 1000, 5000],
    colors: ["#FFEB3B", "#FFC0CB", "#FFD700", "#FF9800", "#FF5722", "#B71C1C"],
  },
  legend: { position: "none" },
};

const GeoChart = () => (
  <div className="flex flex-col items-center p-6 rounded-lg ">
    <div className="w-full flex justify-between">
      <div className="w-3/4">
        <Chart
          chartType="GeoChart"
          width="100%"
          height="500px"
          data={data}
          options={options}
        />
      </div>
      <div className="w-1/4 flex flex-col items-start bg-subtle p-4 rounded-lg shadow-sm ml-6">
        <h4 className="text-lg font-semibold mb-4 text-gray-700">
          Subscription
        </h4>
        <div className="flex items-center mb-3">
          <div className="w-5 h-5 bg-yellow-300 rounded-full mr-3"></div>
          <span className="text-sm text-gray-600">0 - 100</span>
        </div>
        <div className="flex items-center mb-3">
          <div className="w-5 h-5 bg-pink-400 rounded-full mr-3"></div>
          <span className="text-sm text-gray-600">101 - 250</span>
        </div>
        <div className="flex items-center mb-3">
          <div className="w-5 h-5 bg-yellow-600 rounded-full mr-3"></div>
          <span className="text-sm text-gray-600">251 - 500</span>
        </div>
        <div className="flex items-center mb-3">
          <div className="w-5 h-5 bg-orange-500 rounded-full mr-3"></div>
          <span className="text-sm text-gray-600">501 - 1000</span>
        </div>
        <div className="flex items-center mb-3">
          <div className="w-5 h-5 bg-red-500 rounded-full mr-3"></div>
          <span className="text-sm text-gray-600">1001 - 5000</span>
        </div>
        <div className="flex items-center">
          <div className="w-5 h-5 bg-red-900 rounded-full mr-3"></div>
          <span className="text-sm text-gray-600">5001+</span>
        </div>
      </div>
    </div>
  </div>
);

export default GeoChart;
